const config = {
    apiUrl: 'https://digital.allcasino.in:3000/',
    // apiUrl: 'http://127.0.0.1:3000/',
    // apiUrl: 'http://localhost:3000/',

    bUrl: 'http://139.162.213.154:3000/',
    // userTypes: ['Super Admin', 'Master Admin', 'Admin', 'Super Master', 'Master', 'Agent', 'User'],
    // userTypesAlias: {
    //     'super_admin': 'Super Admin', 'master_admin': 'Master Admin', 'admin': 'Admin', 'super_master': 'Super Master', 'master': 'Master', 'agent': 'Agent', 'user': 'User'
    // },
    userTypes: ['Super Admin', 'Admin', 'Super Master', 'Master', 'Agent', 'User'],

    userTypesAlias: {
        'super_admin': 'Super Admin', 'admin': 'Admin', 'super_master': 'Super Master', 'master': 'Master', 'agent': 'Agent', 'user': 'User'
    },
    event_types: {
        4: 'Cricket', 2: 'Tennis', 1: 'Soccer'
    },
    sitecodes: "P56",

    videoUrl: {
        '7ud': ' http://139.162.213.154/dvideo/teen20.html',
        'ab': ' http://139.162.213.154/dvideo/teen20.html',
        'ltp': ' http://139.162.213.154/dvideo/teen20.html',
        't20': ' http://139.162.213.154/dvideo/teen20.html',
        'dt20': ' http://139.162.213.154/dvideo/teen20.html',
        'aaa': ' http://139.162.213.154/dvideo/teen20.html',
        '32c': 'http://45.56.112.18/?id=3084',
    },
    marketSarket: "http://marketsarket.in:3002/"
}


// Define site codes and superAdmin for different domains
const domainConfig = {
    'ag.aura444.us': { sitecodes: 'P32' },
    'ag.aura444.me': { sitecodes: 'P32' },
    'ag.master444.bet': { sitecodes: 'P40' },
    'ag.ptsexch.in': { sitecodes: 'P41' },
    'ag.aura-444.com': { sitecodes: 'P48' },
    'agsky.jaipurapps.com': { sitecodes: 'P56' },
};

// Get the current hostname
const currentDomain = window.location.hostname;

// Assign the site code and superAdmin dynamically based on the domain
if (domainConfig[currentDomain]) {
    config.sitecodes = domainConfig[currentDomain].sitecodes;
    // config.superAdmin = domainConfig[currentDomain].superAdmin;
}


export default config;

export const SOCKET_URL = 'https://digitalws.lce247.com:8040/';

export const CURRENCY_TYPE = 'INR';


